type SemenLinkProps = {
  semenId: string;
  semenName: string;
};

export const SemenLink = ({ semenId, semenName }: SemenLinkProps) => {
  const semenAppUrl = `/semen/detail?semenId=${semenId}`;
  return <a href={semenAppUrl}>{semenName}</a>;
};
